import React from 'react';
import {
  hasPermission, manageSurveyPermission, surveyOverviewPermission, SurveyType
} from 'unihow-common';
import { langType, withLang } from '../../i18n';
import SurveyTypeBox from './SurveyTypeBox';
import { routes } from '../../constants';

import styles from './surveysLandingPage.module.css';
import useTitle from '../../hooks/useTitle';
import useCurrentUser from '../../hooks/useCurrentUser';

const SurveysLandingPage = ({ translate }) => {
  useTitle(translate('surveysLandingPage.title'));
  const { permissions: userPermissions } = useCurrentUser();

  const surveyBoxProps = {
    [SurveyType.DEGREE_PROGRAM_SURVEY]: {
      titleTranslationKey: 'hulSurvey',
      descriptionTranslationKey: 'hulSurveyDescription',
      viewUrl: routes.surveys.hulSurveys.index,
      startSurveyUrl: routes.surveys.hulSurveys.startSurvey.index
    },
    [SurveyType.COURSE_SURVEY]: {
      titleTranslationKey: 'husSurvey',
      descriptionTranslationKey: 'husSurveyDescription',
      viewUrl: routes.surveys.husSurveys.index,
      startSurveyUrl: routes.surveys.husSurveys.startSurvey.index
    },
    [SurveyType.HUP]: {
      titleTranslationKey: 'hupSurvey',
      descriptionTranslationKey: 'hupSurveyDescription',
      viewUrl: routes.surveys.hupSurveys.index,
      startSurveyUrl: routes.surveys.hupSurveys.startSurvey.index
    },
    [SurveyType.HUT]: {
      titleTranslationKey: 'hutSurvey',
      descriptionTranslationKey: 'hutSurveyDescription',
      viewUrl: routes.surveys.hutSurveys.index,
      startSurveyUrl: routes.surveys.hutSurveys.startSurvey.index
    }
  };

  return (
    <div className="page-container">
      <h1>{translate('surveysLandingPage.title')}</h1>
      <div className={styles.boxContainer}>
        {Object.values(SurveyType).map((surveyType) => {
          if (!hasPermission(userPermissions, surveyOverviewPermission(surveyType))) {
            return null;
          }

          const props = surveyBoxProps[surveyType];
          if (!props) {
            return null;
          }

          return (
            <SurveyTypeBox
              key={surveyType}
              type={surveyType}
              title={translate(`surveysLandingPage.${props.titleTranslationKey}`)}
              text={translate(`surveysLandingPage.${props.descriptionTranslationKey}`)}
              viewUrl={props.viewUrl}
              startSurveyUrl={props.startSurveyUrl}
              showStartSurveyButton={hasPermission(userPermissions, manageSurveyPermission(surveyType))}
            />
          );
        })}
      </div>
    </div>
  );
};

SurveysLandingPage.propTypes = {
  ...langType
};

export default (withLang(SurveysLandingPage));
